import {Component, Inject} from '@angular/core';
import {DatePipe} from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {NgSelectComponent} from '@ng-select/ng-select';
import {Project} from '../../classes/project';
import {RegistrationV2} from '../../classes/registration';

interface ProjectOption {
    id: number;
    label: string;
}

export interface ChangeRegistrationProjectDialogData {
    registration: RegistrationV2;
    projects: Project[];
}

@Component({
    selector: 'app-change-registration-project-dialog',
    templateUrl: './change-registration-project-dialog.component.html',
    styleUrls: ['./change-registration-project-dialog.component.scss'],
    imports: [
        DatePipe,
        ReactiveFormsModule,
        NgSelectComponent,
        MatButton,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatDialogTitle
    ]
})
export class ChangeRegistrationProjectDialogComponent {
    readonly projectOptions: ProjectOption[];
    readonly currentProjectLabel: string;
    selectedWorkProjectId = new FormControl<number | null>(null);

    constructor(
        public dialogRef: MatDialogRef<ChangeRegistrationProjectDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ChangeRegistrationProjectDialogData,
    ) {
        this.projectOptions = this.buildProjectOptions(data.projects ?? []);
        this.selectedWorkProjectId.setValue(data.registration.work_project_id);
        this.currentProjectLabel = this.projectOptions.find(project => project.id === data.registration.work_project_id)?.label ?? data.registration.name;
    }

    save() {
        if (!this.selectedWorkProjectId.value || this.selectedWorkProjectId.value === this.data.registration.work_project_id) {
            this.dialogRef.close();
            return;
        }

        this.dialogRef.close(this.selectedWorkProjectId.value);
    }

    private buildProjectOptions(projects: Project[], parents: string[] = [], companyName: null | string = null): ProjectOption[] {
        return projects.flatMap(project => {
            const currentCompanyName = companyName ?? project.company_name ?? null;
            const currentParents = [...parents, project.name];

            if (!project.children?.length) {
                return [{
                    id: project.id,
                    label: [currentCompanyName, ...currentParents].filter(Boolean).join(' » ')
                }];
            }

            return this.buildProjectOptions(project.children, currentParents, currentCompanyName);
        });
    }
}
